import { createSelectorCreator, defaultMemoize } from "reselect";
import { isLookaheadHistogramOpen } from "./lookahead.selector";
import { isPhasePlanHistogramOpen } from "./phaseplan.selector";
import { Point } from "../modules/ui.reducer";
const _ = require('lodash');

export const createDeepEqualSelector = createSelectorCreator(
    defaultMemoize,
    _.isEqual
  )

export const isIterable = (obj:AnimationPlaybackEventInit) => {
    // checks for null and undefined
    if (obj == null) {
      return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
}

export type LookaheadLength = 3 | 6 | 12;

export const isSelectMultiPressed = (state:any) => state.uiReducer.isSelectMultiPressed

export const getKeysPressed = (state:any) => state.uiReducer.keysPressed

export const getLastKeyTime = (state:any) => state.uiReducer.lastKeyTime

export const getZoom = (state:any) => state.uiReducer.zoom

export const getLocationPathName = (state:any) => state.router.location.pathname

export const splitFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}

export const getPointFromDroppableId = (droppableId: string):Point => {
	const splitColumn =  splitFirst(droppableId, '/')

    const newColumnId = splitColumn.length > 1 ? parseInt(splitColumn[0], 10) : null
	const newIndexId = splitColumn.length > 1 ? parseInt(splitColumn[1], 10) : null

	return {
		column: newColumnId,
		row: newIndexId
	}
}









// WEBPACK FOOTER //
// ./src/selectors/util.selector.ts